import { render, staticRenderFns } from "./PaymentZpay.vue?vue&type=template&id=6a5ba8d1&scoped=true&"
import script from "./PaymentZpay.vue?vue&type=script&lang=js&"
export * from "./PaymentZpay.vue?vue&type=script&lang=js&"
import style0 from "./PaymentZpay.vue?vue&type=style&index=0&id=6a5ba8d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5ba8d1",
  null
  
)

export default component.exports